var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef, useContext, useEffect, useRef } from 'react';
import { Animated, View } from 'react-native';
import { LoaderIcon } from '../../icons';
import { StateConfigContext } from '../../providers/state-config-provider/StateConfigProvider';
import { Typography } from '../typography';
import { getLoaderLabelTypes, getLoaderProps, getLoaderStyles } from './LoaderStyles';
import { getInterpolatedRotationValue, startLoadingAnimation } from './LoaderUtils';
import { getTestId } from '../../utils';
export var Loader = forwardRef((props, ref) => {
  var _a, _b;
  var stateContext = useContext(StateConfigContext);
  var loaderProps = getLoaderProps(props, stateContext);
  var loaderStyles = getLoaderStyles(loaderProps);
  var customSize = loaderProps.customSize,
    size = loaderProps.size,
    color = loaderProps.color,
    style = loaderProps.style,
    label = loaderProps.label,
    _loaderProps$testID = loaderProps.testID,
    testID = _loaderProps$testID === void 0 ? 'Loader' : _loaderProps$testID,
    restProps = __rest(loaderProps, ["customSize", "size", "color", "style", "label", "testID"]);
  var animatedRotation = useRef(new Animated.Value(0)).current;
  var loaderSize = customSize || ((_b = (_a = loaderProps === null || loaderProps === void 0 ? void 0 : loaderProps.config) === null || _a === void 0 ? void 0 : _a[size]) === null || _b === void 0 ? void 0 : _b.loaderSize);
  useEffect(() => {
    startLoadingAnimation(animatedRotation);
  }, []);
  var animatedStyle = [{
    rotate: getInterpolatedRotationValue(animatedRotation)
  }];
  return _jsxs(View, Object.assign({
    ref: ref,
    style: [loaderStyles.container, style]
  }, getTestId(testID), restProps, {
    children: [_jsx(View, Object.assign({
      style: loaderStyles.bgColorContainer
    }, {
      children: _jsx(Animated.View, Object.assign({
        style: {
          transform: animatedStyle
        }
      }, {
        children: _jsx(LoaderIcon, Object.assign({
          fontSize: loaderSize,
          color: color
        }, getTestId(testID, 'loaderIcon')))
      }))
    })), !!label && _jsx(Typography, Object.assign({
      type: getLoaderLabelTypes(size),
      text: label,
      style: loaderStyles.label
    }, getTestId(testID, 'label')))]
  }));
});